import { useMatch } from 'react-router-dom';

import { Stack } from '@mui/material';

import {
  AccountUserDto,
  CalendarEventDto,
  CalendarMeetingDto,
  MeetingAnalysisDto
} from '@/api/generated';
import IndependentChatInput from '@/components/AskMeAnything/components/IndependentChatInput/IndependentChatInput';
import MeetingOverview from '@/components/Meeting/components/MeetingOverview/MeetingOverview';
import SharedMeetingOverview from '@/components/Meeting/components/MeetingOverview/SharedMeetingOverview';
import RoutesMap from '@/enums/RoutesMap';

import { Container, MeetingContentContainer } from './MeetingDataStyles';
import MeetingHeader from './MeetingHeader';

const defaultTemplate = {
  id: 'default_template',
  name: 'Default Template',
  context: 'A versatile summary template that works for any meeting or discussion.'
};

const MeetingData = ({
  meeting,
  onTimeClicked,
  event,
  eventLoading,
  usersList,
  sharedMeeting = false,
  meetingAnalysis
}: {
  meeting: CalendarMeetingDto | undefined;
  onTimeClicked: (time: number | undefined) => void;
  event: CalendarEventDto | undefined;
  eventLoading: boolean;
  usersList?: AccountUserDto[];
  sharedMeeting?: boolean;
  meetingAnalysis?: MeetingAnalysisDto | undefined;
}) => {
  const publicMeetingMatch = useMatch(RoutesMap.SharedPublicMeeting);
  const isPublicMeeting = !!publicMeetingMatch;

  return (
    <Container>
      <MeetingHeader
        meeting={meeting}
        event={event}
        usersList={usersList}
        sharedMeeting={sharedMeeting}
      />
      <Stack gap="16px" height={`calc(100% - 56px - 16px)`}>
        {!isPublicMeeting && <IndependentChatInput isRemoveButton={false} isHeader={false} />}
        <MeetingContentContainer sx={{ height: 'calc(100% - 68px)' }}>
          {!sharedMeeting && (
            <MeetingOverview
              meeting={meeting}
              defaultTemplate={defaultTemplate}
              onTimeClicked={onTimeClicked}
            />
          )}
          {sharedMeeting && (
            <SharedMeetingOverview
              meeting={meeting}
              meetingAnalysis={meetingAnalysis}
              onTimeClicked={onTimeClicked}
            />
          )}
        </MeetingContentContainer>
      </Stack>
    </Container>
  );
};
export default MeetingData;
